import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ListingCard } from "../ListingCard";
import { useEffect, useState } from "react";
import { getFeaturedListings } from "../../api/listingApi";

export const FeaturedListing = () => {
  const [featuredListings, setFeaturedListings] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const response = await getFeaturedListings();
        console.log("featured response ",response);
        
        setFeaturedListings(response.listings);
        setIsVisible(true);
      } catch (error) {
        console.error("Error fetching top-rated listings", error);
      }
    };
    fetchFeatured();
  }, []);

  return (
    <section className="mb-24">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-2xl font-bold">Featured Listing</h2>
        <Link
          to="/browse"
          className="text-sage-700 hover:text-sage-800 font-medium flex items-center"
        >
          View All <ChevronRight className="h-4 w-4 ml-1" />
        </Link>
      </div>
      <div
        className={`grid md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 delay-200 transform ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        {featuredListings.map((listing) => (
          <ListingCard
            key={listing._id}
          id={listing._id}
          title={listing.title}
          description={listing.description}
          imageUrl={listing.image}
          location={listing.location}
          date={new Date(listing.createdAt).toLocaleDateString()}
          category={listing.category}
          userName={`${listing.seller?.firstName || "Unknown"} ${listing.seller?.lastName || ""}`}
          userAvatar={listing.seller?.image}
          userRating={listing.seller?.rating}
          // isOwner={listing.seller?._id === currentUserId}
          // currentUserId={currentUserId}
          ownerId={listing.seller?._id}
          isFoundingMember={listing.seller?.isFoundingMember}
          />
        ))}
      </div>
    </section>
  );
};
